import {useTranslation} from "react-i18next";
import SectionDivider from "./common/SectionDivider";
import bg_bottom from '../assets/image/about/bg_bottom.webp';
import {timeline} from "../data/data";
import {NewlineText} from "./common/NewlineText";
import {useRef} from "react";
import ic_right from "../assets/icon/ic_arrow_right_grey.svg";
import ic_left from "../assets/icon/ic_arrow_left_grey.svg";

const SCROLL_WIDTH = 270 * 2

function AboutTimelineSection() {
    const {t} = useTranslation();
    const containerRef = useRef(null)

    const handleScroll = (amount) => {
        containerRef.current.scrollLeft += amount;
    }

    return (
        <div className="bg-green">
            <div className="section">
                <h1>{t('about_history_title')}</h1>
                <SectionDivider/>
                <div className="flex flex-row justify-center items-center">
                    <button className="mr-12 max-md:mr-4"
                            onClick={() => handleScroll(-SCROLL_WIDTH)}>
                        <Arrow icon={ic_left} />
                    </button>
                    <div ref={containerRef}
                         className="flex py-12 max-md:py-8 max-w-70 w-screen max-md:max-w-[60%]
                                    overflow-y-hidden overflow-x-auto scroll-smooth gap-8 max-md:gap-4">
                        {timeline.map((item, index) => (
                            <div key={index}
                                 className="min-w-[270px] max-md:min-w-[220px] flex flex-col justify-start space-y-6">
                                <h2 className="font-bold text-primary text-left text-3xl max-md:text-xl">
                                    {t(item.year)}
                                </h2>
                                <div className="font-bold text-left pl-8 text-base max-md:text-sm
                                    h-full border-l-[6px] border-primary-light">
                                    <NewlineText text={t(item.text)}/>
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className="ml-12 max-md:ml-4" onClick={() => handleScroll(SCROLL_WIDTH)}>
                        <Arrow icon={ic_right}/>
                    </button>
                </div>
            </div>
            <img src={bg_bottom} alt="Bottom Backgronud"
                 className="w-full pb-10 max-md:pb-4 opacity-45 max-md:h-24 object-cover"/>
        </div>
    )
}

const Arrow = (props) => {
    return (
        <div className="rounded-full w-10 h-10 bg-white flex justify-center items-center p-2 shadow-md">
            <img src={props.icon} alt="Arrow Icon"/>
        </div>
    )
}

export default AboutTimelineSection;